import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MenuFunctionalityEnum } from 'src/app/shared/menu/menu.functionality.enum';
import { MenuModuleEnum } from 'src/app/shared/menu/menu.module.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { TemplateManipulationService } from 'src/app/shared/services/API/pharmacy/template-manipulation.service';
import { TemplateMedicineService } from 'src/app/shared/services/API/pharmacy/template-medicine.service';
import { TemplateModel } from 'src/app/shared/services/models/pharmacy/template.model';
import { CompleteTemplateMedicineStruct } from 'src/app/shared/services/structs/pharmacy/complete-template.medicine.struct';
import { TemplateMedicineDeleteModalComponent } from './template-medicine-delete-modal/template-medicine-delete-modal.component';

@Component({
  selector: 'app-template-medication',
  templateUrl: './template-medication.component.html',
  styleUrls: ['./template-medication.component.css']
})
export class TemplateMedicationComponent implements OnInit {

  constructor(private templateMedicineService: TemplateMedicineService,
    private templateManipulationService: TemplateManipulationService,
    private alertService: AlertService,
    public dialog: MatDialog
  ) { }
    
  public menuModuleEnum:MenuModuleEnum = MenuModuleEnum.consulting;
  public menuFunctionalityEnum:MenuFunctionalityEnum = MenuFunctionalityEnum.consulting_template_medicine;
    
  public isLoading: boolean;
  public searchText: string;
  public idTemplate: number;
  public listTemplate: TemplateModel[];
  public listTemplateMedicine: CompleteTemplateMedicineStruct[];

  ngOnInit(): void {
    this.isLoading = true;
    this.listAllTemplate();
    this.search();
  }

  search(){
    this.isLoading = true;  
    if(this.searchText == "")
      this.searchText = null;
    
    this.templateMedicineService.list(this.searchText, this.idTemplate).subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      this.listTemplateMedicine = response.listTemplateMedicine; 

      this.isLoading = false;    
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;    
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }

  

  private timeoutKeySearch: any = null;
  
  onKeySearch(event: any) {
    clearTimeout(this.timeoutKeySearch);
    var $this = this;
    this.timeoutKeySearch = setTimeout(function () {
      if (event.keyCode != 13) {
        $this.search();
      }
    }, 1000);
  }
  
  openModal(idTemplateMedicine: number){
    const dialogRef = this.dialog.open(TemplateMedicineDeleteModalComponent, {
      data: {
        idTemplateMedicine: idTemplateMedicine
      },
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if(result && result.deleteTemplateMedicine){
        this.search();
      }
    });
  }

  listAllTemplate(){
    this.templateManipulationService.listAllTemplate().subscribe((response)=>{
      
      if(response.isError){
        this.alertService.show('Erro', response.errorDescription, AlertType.error);
        this.isLoading = false;
        return;
      }
      
      this.listTemplate = response.listTemplate;  
    
      this.isLoading = false;    
    },
    (error)=>{
      console.log(error)
      this.isLoading = false;    
      this.alertService.show('Erro inesperado', error, AlertType.error);
    });
  }
}
